module.exports = __webpack_public_path__ + "static/media/suresh_raut.0eb60416.jpg";